import * as React from 'react';
import CookieChecker from "../shared/cookie-checker/CookieChecker";
import { WhatsappButton } from "../../components/style-guide/whatsapp-button/whatsapp-button"
import clsx from "clsx";

export const Empty = (props) => {
  const { children, className, disabledWhatsapp = false } = props;

  return (
    <div className={clsx("viewport-container-fixed", className)}>
      {children}
      <CookieChecker />
      {!disabledWhatsapp && <WhatsappButton />}
    </div>
  );
};

export default Empty;
